import React, { useState } from "react";
import FirstIntro from "./FirstIntro";
import OperationTimer from "./OperationTimer";
import UsersIcon from "@material-ui/icons/People";
import GameIcon from "@material-ui/icons/Games";
import { useMediaQuery, IconButton } from "@material-ui/core";
import { useTheme } from '@material-ui/core/styles';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { grey } from '@material-ui/core/colors';
import SwipeableViews from 'react-swipeable-views';
import BitcoinIcon from '@iconify/icons-mdi/bitcoin';
import SecondIntro from "./SecondIntro";
import ThirdIntro from "./ThirdIntro";
import AppColors from './../colors/AppColors';

const OnBoarder = React.forwardRef(function (props: any) {

    const appInitData = props.data;
    const theme = useTheme();
    const desktopMode = useMediaQuery(theme.breakpoints.up(1040))
    const superSmallMode = useMediaQuery(theme.breakpoints.down(600));
    const inMobileMode = useMediaQuery(theme.breakpoints.down(641));
    const [activeStep, setActiveStep] = useState(0);
    const height = inMobileMode ? '100vh' : '77vh';

    const mergeSections = (firstSection: any, secondSection: any) => {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-evenly',
                    alignItems: 'center',
                }}>
                {firstSection}
                {secondSection}
            </div>
        );
    }

    const singleSection = (section: any) => {
        return (
            <div>{section}</div>
        );
    }

    const mergedPages = [
        mergeSections(
            <FirstIntro height={height} />,
            <SecondIntro height={height} />
        ),
        singleSection(<ThirdIntro height={height} />)
    ];

    const unMergedPages = [
        singleSection(<FirstIntro height={height} mode={desktopMode}
            buttonMode={superSmallMode} />),
        singleSection(<SecondIntro height={height} mode={desktopMode}
            buttonMode={superSmallMode} />),
        singleSection(<ThirdIntro height={height} mode={desktopMode}
            buttonMode={superSmallMode} />)
    ]

    const pages: any = desktopMode ? mergedPages : unMergedPages;

    const handleNext = () => {
        const nextStep = activeStep + 1;
        setActiveStep(nextStep);
    }

    const handleBack = () => {
        const nextStep = activeStep - 1;
        setActiveStep(nextStep);
    }

    const handleStepChange = (step: number) => {
        setActiveStep(step);
    }

    const OnBoardViewPager = () => {
        return (
            <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
                style={{
                    overflowX: 'hidden',
                }}>
                {
                    pages.map((_step: any, index: number) => (
                        <div key={index}>
                            {
                                pages[index]
                            }
                        </div>
                    ))
                }
            </SwipeableViews>
        );
    }

    const OperationTimersParent = () => {
        return <div style={{
            backgroundColor: AppColors.PRIMARY_COLOR,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
            flexWrap: 'wrap',
        }}>
            <OperationTimer icon={UsersIcon}
                count={`${Math.floor(parseInt(appInitData.totalUsersCount) * 0.5)}`}
                description="REGISTERED USERS"
                target={appInitData.totalUsersCount}
                canDispatch={true} />
            <OperationTimer icon={GameIcon}
                count={`${Math.floor(parseInt(appInitData.totalGamesPlayed) * 0.5)}`}
                description="Games Played"
                target={appInitData.totalGamesPlayed} />
            <OperationTimer icon={BitcoinIcon} external
                count={`${parseInt(appInitData.totalPaidOutAmountInBTC) * 0.5}`}
                description="PAID OUT"
                target={appInitData.totalPaidOutAmountInBTC}
                step="0.00000001" />
        </div>
    }

    const OnBoardIndicatorArrows = () => {
        return <div>
            {
                activeStep !== 0 &&
                <IconButton onClick={handleBack}
                    style={{
                        position: 'absolute',
                        top: desktopMode ? window.innerHeight / 2 : window.innerHeight / 3,
                        left: 0,
                        flexDirection: 'row',
                        background: 'none',
                        zIndex: 1
                    }}>
                    <KeyboardArrowLeft style={{ fontSize: 60, color: grey[100] }} />
                </IconButton>
            }
            {
                activeStep !== pages.length - 1 &&
                <IconButton onClick={handleNext} style={{
                    position: 'absolute',
                    top: desktopMode ? window.innerHeight / 2 : window.innerHeight / 3,
                    right: 0,
                    flexDirection: 'row',
                    background: 'none',
                    zIndex: 1
                }}>
                    <KeyboardArrowRight style={{ fontSize: 60, color: grey[100] }} />
                </IconButton>
            }
        </div>
    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                background: `url(${require('./../images/backgroundanim.gif')})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                overflowX: 'hidden',
                backgroundPosition: 'center'
            }}>
            <div
                style={{
                    flexDirection: 'column',
                }}>
                {OnBoardViewPager()}
                <OnBoardIndicatorArrows />
                <OperationTimersParent />
            </div>
        </div>
    );
});

export default OnBoarder;